<template>
  <div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>

    <div class="columns is-multiline">
      <!-- 주문상품 -->
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="주문상품">
            <div class="columns is-multiline">
              <div class="column is-full" v-if="purchase_product.length>0">
                <table class="table">
                  <thead>
                  <tr>
                    <td>이미지</td>
                    <td>상품명</td>
                    <td>수량</td>
                    <td>판매가</td>
                    <td>삭제</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(purchase,idx) in purchase_product" :key="'purchase-'+idx">
                    <td><div style="text-align: center; display: inline-block;"
                             :style="imgField(purchase.img)"></div></td>
                    <td>{{ purchase.name }}</td>
                    <td><input class="input product-short-input"
                             :value="purchase.quantity"
                             @input="e=>setNumber(e, purchase, 'quantity', 3)"
                             type="number"></td>
                    <td>{{ purchase.total_price | currency }}</td>
                    <td><button class="button is-danger" @click="deletePurchase(idx)">삭제</button></td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="column is-full">
                <div class="flex btn-group-justify-end">
                  <button class="button" @click="clickProduct">상품추가</button>
                </div>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
      <!-- 주문자 정보 -->
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="주문자 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="회원구분">
                  <div class="flex">
                    <lp-radio :val.sync="is_user"
                              value_name="value"
                              label_name="label"
                              :data="is_user_arr"></lp-radio>
                    <button class="button" v-if="is_user" @click="$modal.show('userlistModal')">회원선택</button>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="주문자명*">
                  <input class="input"
                         :value="purchase.name"
                         @input="e=>purchase.name=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="전화번호">
                  <input class="input"
                         :value="purchase.tphone"
                         @input="e=>purchase.tphone=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="휴대전화번호*">
                  <input class="input"
                         :value="purchase.mphone"
                         @input="e=>purchase.mphone=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="이메일*">
                  <input class="input"
                         :value="purchase.email"
                         @input="e=>purchase.email=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="주소*">
                  <lp-address :data.sync="purchase.address"></lp-address>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <!-- 받는 분 정보 -->
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="수령자 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <lp-check-bool :checkedVal.sync="isEqualUser"
                               label="파트너 정보와 상품 정보가 동일합니다."></lp-check-bool>
              </div>
              <div class="column is-full">
                <admin-form-item label="수령자명*">
                  <input class="input"
                         :value="delivery.name"
                         @input="e=>delivery.name=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="전화번호">
                  <input class="input"
                         :value="delivery.tphone"
                         @input="e=>delivery.tphone=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="휴대전화번호*">
                  <input class="input"
                         :value="delivery.mphone"
                         @input="e=>delivery.mphone=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="주소*">
                  <lp-address :data.sync="delivery.address"></lp-address>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="배송 메시지">
                  <input class="input"
                         :value="delivery.memo"
                         @input="e=>delivery.memo=e.target.value"
                         type="text" maxlength="100">
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
      <!-- 결제정보 -->
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="결제정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="상품합계금액">
                  {{ purchase.product_price | currency }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="배송비">
                  {{ purchase.delivery_price | currency }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="최종 결제 금액">
                  {{ purchase.total_price | currency }}
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <!-- 결제수단 -->
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="환불 받을 계좌">
            <div class="columns is-multiline">
              <div class="column is-2">
                <admin-form-item label="은행*">
                  <input class="input"
                         :value="purchase.refund_info.bank"
                         @input="e=> purchase.refund_info.bank = e.target.value">
                </admin-form-item>
              </div>
              <div class="column is-2">
                <admin-form-item label="이름*">
                  <input class="input"
                         :value="purchase.refund_info.name"
                         @input="e=> purchase.refund_info.name = e.target.value">
                </admin-form-item>
              </div>
              <div class="column is-2">
                <admin-form-item label="계좌번호*">
                  <input class="input"
                         :value="purchase.refund_info.account"
                         @input="e=> purchase.refund_info.account = e.target.value">
                </admin-form-item>
              </div>
              <!--<div class="column is-full">
                <admin-form-item label="입금계좌*">
                  <span class="select">
                    <select v-model="purchase.bank" @change="selectBank">
                      <option v-for="bank in banklist">{{ bank.label }}</option>
                    </select>
                  </span>
                </admin-form-item>
              </div>-->
            </div>
          </admin-box-item>
        </div>
      </div>

      <!-- 상품 목록 팝업 -->
      <modal name="productlistModal"
             :adaptive="true"
             :width="900"
             height="auto"
             class="modal-style">
        <lp-purchase-product-create
          @addProduct="addProduct"
          @closeModal="$modal.hide('productlistModal')"></lp-purchase-product-create>
      </modal>

      <!-- 회원 목록 팝업 -->
      <modal name="userlistModal"
             :adaptive="true"
             :width="900"
             height="auto"
             class="modal-style">
        <user-list page="purchase" @selectUser="selectUser"></user-list>

      </modal>
    </div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>
  </div>
</template>

<script>
  import LpCheckBool from "../../../../module/common/LpCheckBool";
  import LpAddress from "../../../../module/common/LpAddress";
  import LpPurchaseProductCreate from "../../../../module/custom/LpPurchaseProductCreate";
  import LpRadio from "../../../../module/common/LpRadio";
  import UserList from "../../../user/UserList";
  import Const from "../../../../../utils/const"

  export default {
    components: {
      UserList,
      LpRadio,
      LpPurchaseProductCreate,
      LpAddress,
      LpCheckBool},
    data() {
      return {
        // 주문
        purchase: {
          user_id: 1,
          name: "",
          tphone: "",
          mphone: "",
          email: "",
          address: {
            sido: "",
            sigungu: "",
            dong: "",
            detail: "",
            post_code: "",
            old: "",
            new: "",
            latitude: "",
            longitude: ""
          },
          refund_info: {
            name: "",
            account: "",
            bank: ""
          },
          total_price: 25000,
          discount_price: 0,
          delivery_price: 2500,
          pay_type: 2,  // 무통장 입금
          deposit_name: '',
          bank: ''
        },
        // 주문 상품
        purchase_product: [],
        // 배송지
        delivery: {
          name: "",
          tphone: "",
          mphone: "",
          address: {
            sido: "",
            sigungu: "",
            dong: "",
            detail: "",
            post_code: "",
            old: "",
            new: "",
            latitude: "",
            longitude: ""
          },
          memo: ""
        },
        // 주문자 정보와 동일
        isEqualUser: false,
        is_user: false,
        is_user_arr: [
          { label: '비회원', value: false },
          { label: '회원', value: true }
        ],
        // 은행 계좌 목록
        banklist: []
      }
    },
    computed: {

    },
    watch: {
      isEqualUser(n){
        if(n) this.equalUser();
        else this.initDelivery();
      }
    },
    created() {

    },
    methods: {
      totalProductPrice(){
        let total = 0;
        for(let i=0; i<this.purchase_product.length; i++){
          total += this.purchase_product[i].total_price * this.purchase_product[i].quantity;
        }
        this.purchase.product_price = total;
      },
      totalDeliveryPrice(){
        let total = 0;
        let partner_id = '';
        for (let i=0; i<this.purchase_product.length; i++){
          if (partner_id===''){
            partner_id = this.purchase_product.partner_id;
            total += this.purchase_product[i].delivery_price;
          }
          else if(partner_id!==this.purchase_product.partner_id){
            partner_id = this.purchase_product.partner_id;
            total += this.purchase_product[i].delivery_price;
          }
        }
        this.purchase.delivery_price = total;
      },
      totalPrice(){
        this.purchase.total_price = this.purchase.product_price + this.purchase.delivery_price;
      },
      // const.js 에 저장된 타입값을 가져옴
      convertType(property, status){
        return Const[property][status]
      },
      // 배송지 정보 초기화
      initDelivery(){
        this.delivery = {
          name: "",
          tphone: "",
          mphone: "",
          address: {
            sido: "",
            sigungu: "",
            dong: "",
            detail: "",
            post_code: "",
            old: "",
            new: "",
            latitude: "",
            longitude: ""
          },
          memo: ""
        }
      },
      // 주문자와 동일
      equalUser(){
          this.delivery.name = this.purchase.name;
          this.delivery.tphone = this.purchase.tphone;
          this.delivery.mphone = this.purchase.mphone;
          this.delivery.email = this.purchase.email;
          this.delivery.address = this.purchase.address;
      },
      deletePurchase(index){
        removeIndex(this.purchase_product,index);
      },
      addProduct(value){
        this.purchase_product = this.purchase_product.concat(value);
        this.totalProductPrice();
        this.totalDeliveryPrice();
        this.totalPrice();
        this.$modal.hide('productlistModal');
      },
      // 무통장 목록
      getNoPass(){
        this.$axios.get('public/commerce/bank').then(res=>{
          if(res.status === 200) {
            this.banklist = res.data;
          }
        })
      },
      // 입금계좌 선택
      selectBank(e){
        console.log(e)
        this.purchase.bank = e.target.value;
        ///
      },
      clickProduct(){
        this.$modal.show('productlistModal');
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;';
      },
      setNumber(e, purchase, type, max_length){
        if (type === 'quantity') {
          if( e.target.value.length > max_length ){
            purchase.quantity = e.target.value.substr(0,max_length);
          }
          else {
            purchase.quantity = e.target.value;
          }
        }
      },
      // 유저 선택
      selectUser(value){
        this.purchase.user_id = value.id;
        this.purchase.name = value.name;
        this.purchase.mphone = value.phone;
        this.purchase.email = value.email;
        let address = {
          sido: "",
          sigungu: "",
          dong: "",
          detail: "",
          post_code: "",
          old: "",
          new: "",
          latitude: "",
          longitude: ""
        }
        if(value.address) address = value.address
        this.purchase.address = address;
        this.$modal.hide('userlistModal');
      },
      // 수기주문 등록
      saveData(){
        let result = this.validCheck();
        if(result===false) return;
        this.$axios.post(this.getUrl('commerce/purchase'),{
          purchase: this.purchase,
          purchase_product: this.purchase_product,
          delivery: this.delivery
        }).then(res=>{
          if(res.status === 200) {
            this.toast('주문이 등록되었습니다.');
            this.$router.replace(this.getPath('commerce/purchase/new'));
          }
        })
      },
      // 필수입력값 체크
      validCheck(){
        let err = '';
        if(!this.purchase.name) err = '주문자명을 입력하세요.';
        else if(!this.purchase.mphone) err = '주문자 휴대전화번호를 입력하세요.';
        else if(!this.purchase.email) err = '주문자 이메일을 입력하세요.';
        else if(!this.purchase.address.sido) err = '주문자 주소를 입력하세요.';
        else if(!this.purchase.address.detail) err = '주문자 상세 주소를 입력하세요.';
        else if(!this.delivery.name) err = '수령자명을 입력하세요.';
        else if(!this.delivery.mphone) err = '수령자 휴대전화번호를 입력하세요.';
        else if(!this.delivery.address.sido) err = '수령자 주소를 입력하세요.';
        else if(!this.delivery.address.detail) err = '수령자 상세주소를 입력하세요.';
        else if(!this.purchase.refund_info.name) err = '환불받을 시 이름을 입력하세요.';
        else if(!this.purchase.refund_info.account) err = '환불받을 시 계좌를 입력하세요.';
        else if(!this.purchase.refund_info.bank) err = '환불받을 시 은행을 입력하세요.';
        /*else if(!this.purchase.deposit_name) err = '입금자명을 입력하세요.';
        else if(!this.purchase.bank) err = '입금계좌를 입력하세요.';*/

        else if(this.purchase_product.length===0) {
          err = '상품을 선택하세요.';
        }
        if(err) {
          this.toast(err);
          return false;
        }
        else return true;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .product-short-input
    width 89px
</style>
